module.exports = __webpack_public_path__ + "static/media/feature-portfolio.1b9bef51.png";